import {
  Component,
  Inject,
  Injector,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Store } from '@ngrx/store';

import { FormValues, TranslationService } from '@alfresco/adf-core';
import { NodeEntry } from '@alfresco/js-api';

import { AppStore } from '../../store/states/app.state';
import { ReloadDocumentListAction } from '../../store/actions/app.custom-actions';
import { SnackbarType } from '../../enums';
import { CustomContentManagementService } from '../../services/custom-content-management.service';

export interface NodeProcessDialogData {
  nodes: NodeEntry[];
}

@Component({
  templateUrl: './node-process.dialog.html',
  styleUrls: ['./node-process.dialog.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class NodeProcessDialogComponent implements OnInit {
  nodeId: string;

  public readonly formValues: FormValues = { documentattached: [] };
  private readonly translationService: TranslationService;
  private readonly customContentService: CustomContentManagementService;
  constructor(
    injector: Injector,
    @Inject(MAT_DIALOG_DATA) private readonly data: NodeProcessDialogData,
    private readonly snackBar: MatSnackBar,
    private readonly store: Store<AppStore>,
    public readonly containingDialog?: MatDialogRef<
      NodeProcessDialogComponent,
      void
    >
  ) {
    this.translationService =
      injector.get<TranslationService>(TranslationService);
    this.customContentService = injector.get<CustomContentManagementService>(
      CustomContentManagementService
    );
  }

  public ngOnInit(): void {
    this.data.nodes.forEach((node: NodeEntry) => {
      this.formValues.documentattached.push(node.entry);
      this.nodeId = node.entry.id;
    });
  }

  startProcess() {
    const message = this.translationService.instant(
      'APP.ACTIONS.PROCCESS_STARTED'
    );
    this.containingDialog.close();
    this.snackBar.open(message, '', {
      panelClass: SnackbarType.Info,
      duration: 3000,
    });
    this.store.dispatch(new ReloadDocumentListAction());
    this.customContentService.processStarted.next(this.nodeId);
  }

  public closeDialog(): void {
    this.containingDialog.close();
  }
}
